import { numberFormat } from '../helpers/budgetHelper';

const ReportCard: React.FC<{
  title: string;
  value: number;
  dataTestId?: string;
}> = ({ title, value, dataTestId }) => {
  return (
    <div
      className='border border-light-pastel-blue shadow-header rounded px-4 py-5 flex flex-col gap-y-2 items-end text-right'
      data-testid={`report-card-${dataTestId}`}
    >
      <div className='font-semibold'>{title}</div>
      <div
        className={`text-2xl font-bold ${value < 0 ? 'text-error-darker' : ''}`}
      >
        {value < 0 ? '-$' : '$'}
        {numberFormat(Math.abs(value))}
      </div>
    </div>
  );
};

export default ReportCard;
